module.exports = __webpack_public_path__ + "media/images/icon-search-1bf745ac1e82a2c0a82aff8d4a8b57e5.png";